import { MoneyCollectOutlined } from '@ant-design/icons'

import { RouteItem } from '@eastcoal/router/types/route'

import { FUND_PAGE_UUID, FUND_MANAGE_BANK_ACTION_UUID } from './constants/uuid'

export const fundRoute: RouteItem = {
  title: '资金管理',
  uuid: FUND_PAGE_UUID,
  hideChildrenInMenu: true,
  path: '/fund',
  icon: <MoneyCollectOutlined />,
  Component: () => import('./index'),
  children: [
    {
      title: '管理银行账户',
      uuid: FUND_MANAGE_BANK_ACTION_UUID
    }
  ]
}
